export default {
    home_page_title: "Account Data",
    security_page_title: "Security Center",
    security_setting_page_title: "Security Center",
    security_phone_label: "Cellphone",
    security_email_label: "E-mail",
    security_question_label: "Password questions",
    security_unset_text: "Unset",
    security_setted_text: "Set",
    security_question_options: [
        "What is your mother name?",
        "What is your partner name?",
        "What is your best friend name?",
        "What is your student number?",
        "Who is your favorite star?",
        "Who has affected you deepest?"
    ],
    password_lost_page_title: "Forgot password",
    password_reset_page_title: "Reset the password",
    password_lost_account_placeholder:
        "Enter the account of which the password is forgotten",
    empty_lost_account_tips: "Username should not be empty",
    iscorrect_lost_account_tips: "User does not exist",
    password_reset_new_placeholder: "New password",
    password_reset_confirm_placeholder: "Confirm new password",
    password_verify_page_title: "Verify",
    phone_verify_page_title: "Verify",
    email_verify_page_title: "Verify",
    question_verify_page_title: "Verify",
    phone_reset_page_title: "Cellphone",
    email_reset_page_title: "E-mail",
    question_reset_page_title: "Password questions",
    phone_binding_text: "Your bound cellphone number is",
    email_binding_text: "Your bound email address is",
    verification_code_text: "Verification code",
    resend_text: "Resending",
    empty_phone_number_tips: "Please input the cellphone number",
    iscorrect_phone_number_tips: "Please enter a valid phone number",
    empty_verification_code_tips: "Please input the verification code",
    iscorrect_verification_code_tips: "Verification code error",
    password_placeholder: "Password",
    empty_password_tips: "Enter password",
    iscorrect_password_tips: "Wrong password",
    mismatched_rule_password_tips:
        "The password must not contain &, # or spaces",
    different_confirm_password_tips: "Passwords do not match",
    empty_email_tips: "Please enter email address",
    iscorrect_email_tips: "Wrong email address",
    answer_placeholder: "Answer",
    empty_question_tips: "Choose a security question",
    empty_answer_tips: "Give your answer here",
    iscorrect_answer_tips: "Wrong answer",
    next_step_text: "Next",
    submit_text: "Submit",
    submit_success_tips: "Success",
    submit_error_tips: "Operation failed, please try again",
    get_data_fail_tips: "Network problem, please try again later",
    use_other_verification_type_text: "Verify in other means",
    custom_support_notice:
        "This account has not set any way to retrieve your password. Follow this link using a computer to apply:" +
        process.env.VUE_APP_ORIGIN_PROFILE
};
